import type { Feature } from './PricingCard';

export interface PricingPlan {
  readonly id: string;
  readonly title: string;
  readonly description: string;
  readonly features: readonly Feature[];
  readonly price?: {
    readonly monthly?: {
      readonly amount: number;
      readonly currency: string;
    };
    readonly annual?: {
      readonly amount: number;
      readonly currency: string;
    };
    readonly lifetime?: {
      readonly amount: number;
      readonly currency: string;
    };
  };
  readonly isHighlighted?: boolean;
}

export const createFreeFeatures = (t: (key: string) => string): readonly Feature[] => [
  { text: t('pricing.features.capture'), isAvailable: true },
  { text: t('pricing.features.regionCapture'), isAvailable: true },
  { text: t('pricing.features.clipboard'), isAvailable: true },
  { text: t('pricing.features.video30fps'), isAvailable: true },
  { text: t('pricing.features.filesViewer'), isAvailable: true },
  { text: t('pricing.features.mediaViewer'), isAvailable: true },
  { text: t('pricing.features.floatingWidget'), isAvailable: true },
  { text: t('pricing.features.imageEdition'), isAvailable: false, isComingSoon: true },
] as const;

export const createPremiumFeatures = (t: (key: string) => string): readonly Feature[] => [
  { text: t('pricing.features.allFreeFeatures'), isAvailable: true },
  { text: t('pricing.features.highRefreshRate'), isAvailable: true },
  { text: t('pricing.features.videoWithSound'), isAvailable: true },
  { text: t('pricing.features.pipRecording'), isAvailable: true },
  { text: t('pricing.features.videoToGif'), isAvailable: false, isComingSoon: true },
  { text: t('pricing.features.videoEdition'), isAvailable: false, isComingSoon: true },
  { text: t('pricing.features.subtitles'), isAvailable: false, isComingSoon: true },
] as const;

export const createPricingPlans = (t: (key: string) => string): readonly PricingPlan[] => [
  {
    id: 'free',
    title: t('pricing.plans.free.title'),
    description: t('pricing.plans.free.description'),
    features: createFreeFeatures(t),
  },
  {
    id: 'premium',
    title: t('pricing.plans.premium.title'),
    description: t('pricing.plans.premium.description'),
    features: createPremiumFeatures(t),
    price: {
      monthly: {
        amount: 3,
        currency: '€',
      },
      annual: {
        amount: 30,
        currency: '€',
      },
      lifetime: {
        amount: 35,
        currency: '€',
      },
    },
    isHighlighted: true,
  },
] as const;
